import { View } from '@react-pdf/renderer';
import { Style } from '@react-pdf/types';

import { tableStyles } from '../Table/tableStyles.js';
import { Text } from '../Text/Text.js';
import { sharedStyles } from '../sharedStyles.js';

type Props = {
  style?: Style;
  children: string;
};

export function Th({ style = {}, children }: Props) {
  return (
    <View style={[tableStyles.cell, sharedStyles.fullWidth, sharedStyles.verticalCenter, style]}>
      <Text variant="th">{children}</Text>
    </View>
  );
}
